import { gql } from 'react-apollo';

export const deleteRevival = gql`
  mutation deleteRevival($input: DeleteRevivalInput!) {
    deleteRevival(input: $input) {
      revival {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/revivals/mutations/deleteRevival.js